import http from '../../utils/httpService';
import { USERS_ROUTE } from './constants';

/**
 *
 * @returns {*}
 */
const requestUsers = () => (
    http.request( USERS_ROUTE, 'GET', null, false )
);

/**
 *
 * @param formData
 * @returns {*}
 */
const requestInviteUser = ( formData ) => {
    return http.request( USERS_ROUTE, 'POST', formData );
};

/**
 *
 * @param formData
 * @returns {*}
 */
const requestUpdateUser = ( formData ) => {
    const route = USERS_ROUTE + `/${ formData.id }`;
    return http.request( route, 'PUT', formData );
};

/**
 *
 * @param themeID
 */
const requestDeleteUser = userID => {
    const route = USERS_ROUTE + `/${ userID }`;
    return http.request( route, 'DELETE' );
};

export {
    requestUsers,
    requestInviteUser,
    requestUpdateUser,
    requestDeleteUser,
};

